"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _RadioButtonComponent.default;
  }
});

var _RadioButtonComponent = _interopRequireDefault(require("./RadioButton-component"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }